import TableOfContents, { Item } from './TableOfContents';
import SideTableOfContents from './SideTableOfContents';
import { scrollWithOffset } from './utils';

export type { Item };
export { SideTableOfContents, scrollWithOffset };
export default TableOfContents;
